import NotificacionGestorService from "@/api/services/notificacion/NotificacionGestorService"
import Vue from "vue"

const state = () => ({
    gestores_notificacion: [],
    pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: "id",
        rowsPerPageItems: [5, 10, 20, 30, 40, 50]
    }
})

const getters = {
    GESTORES_NOTIFICACION: state => {
        return state.gestores_notificacion
    },
    GESTORES_NOTIFICACION_PAG: state => {
        return state.pagination
    }
}

const mutations = {
    SET_GESTORES_NOTIFICACION: (state, payload) => {
        state.gestores_notificacion = payload
    },

    SET_GESTORES_NOTIFICACION_PAG: (state, payload) => {
        state.pagination = payload
    },

    ADD_GESTOR_NOTIFICACION: (state, payload) => {
        state.gestores_notificacion.push(payload)
    },

    UPDATE_GESTOR_NOTIFICACION: (state, payload) => {
        state.gestores_notificacion = state.gestores_notificacion.map(el => (el.id === payload.id ? payload : el))
    },

    DELETE_GESTOR_NOTIFICACION: (state, payload) => {
        state.gestores_notificacion = state.gestores_notificacion.filter(el => el.id !== payload.id)
    }
}

const actions = {
    LOAD_GESTORES_NOTIFICACION: async ({ commit, state }, { filter, notificacionEstado, customfilter }) => {
        try {
            let pagination = {
                page: state.pagination.page,
                rowsPerPage: state.pagination.rowsPerPage,
                sortBy: state.pagination.descending ? "-" + state.pagination.sortBy : state.pagination.sortBy
            }
            let { data, status, headers } = await NotificacionGestorService.get({
                filter,
                notificacionEstado,
                customfilter,
                ...pagination
            })
            if (status === 200) {
                commit("SET_GESTORES_NOTIFICACION", data)
                return parseInt(headers["x-pagination-total-count"])
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los gestores de notificación, inténtelo nuevamente"
            })
        }
    },

    LOAD_ALL_GESTORES_NOTIFICACION: async ({ commit }) => {
        try {
            let { data, status } = await NotificacionGestorService.getAll()
            if (status === 200) {
                commit("SET_GESTORES_NOTIFICACION", data)
                return data
            }
        } catch (error) {
            if (error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se han podido cargar los gestores de notificación, inténtelo nuevamente"
                })
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    LOAD_ALL_RECORDS_GESTORES_NOTIFICACION: async ({ commit }) => {
        try {
            let { data, status } = await NotificacionGestorService.getAllRecords()
            if (status === 200) {
                commit("SET_GESTORES_NOTIFICACION", data)
                return null
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los gestores de notificación, inténtelo nuevamente"
            })
        }
    },

    ADD_GESTOR_NOTIFICACION: async ({ commit }, payload) => {
        try {
            let { data, status } = await NotificacionGestorService.post(payload)
            if (status === 201) {
                commit("ADD_GESTOR_NOTIFICACION", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Agregando",
                    text: "El gestor de notificación ha sido agregado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido agregar el gestor de notificación, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    UPDATE_GESTOR_NOTIFICACION: async ({ commit }, payload) => {
        try {
            let { data, status } = await NotificacionGestorService.put(payload)
            if (status === 200) {
                commit("UPDATE_GESTOR_NOTIFICACION", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Modificando",
                    text: "El gestor de notificación ha sido modificado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido modificar el gestor notificación, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    DELETE_GESTOR_NOTIFICACION: async ({ commit }, payload) => {
        try {
            let { status, data } = await NotificacionGestorService.delete(payload)
            if (status === 204) {
                commit("DELETE_GESTOR_NOTIFICACION", payload)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Eliminando",
                    text: "El gestor de notificación ha sido eliminado satisfactoriamente"
                })
            }
            if (status === 200) {
                commit("UPDATE_GESTOR_NOTIFICACION", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Deshabilitando",
                    text: "El gestor de notificación ha sido deshabilitado satisfactoriamente"
                })
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido eliminar/deshabilitar el gestor de notificación, inténtelo nuevamente"
            })
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
